import { ExcelColumn } from "api/generated/lumen";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface UseRepairmanListColumnTitles {
  columnTitles: string[];
  columnTitlesForExcel: ExcelColumn[];
}

const useRepairmanListColumnTitles = (
  contractorId?: string
): UseRepairmanListColumnTitles => {
  const { t } = useTranslation();

  const columnTitles = useMemo(
    () =>
      [
        t("repairmen.familyname"),
        t("repairmen.forename"),
        t("repairmen.email"),
        t("repairmen.phone"),
        t("repairmen.contractor"),
        t("repairmen.status"),
      ].filter((el) => (contractorId ? el !== t("repairmen.contractor") : el)),
    [t, contractorId]
  );

  const columnTitlesForExcel = useMemo(
    () => [
      {
        displayName: t("repairmen.familyname"),
        propertyName: "familyname",
      },
      {
        displayName: t("repairmen.forename"),
        propertyName: "forename",
      },
      {
        displayName: t("repairmen.email"),
        propertyName: "email",
      },
      {
        displayName: t("repairmen.phone"),
        propertyName: "phone",
      },
      {
        displayName: t("repairmen.contractor"),
        propertyName: "contractor",
      },
      {
        displayName: t("repairmen.status"),
        propertyName: "status",
      },
    ],
    [t]
  );

  return {
    columnTitles,
    columnTitlesForExcel,
  };
};

export default useRepairmanListColumnTitles;
